module.exports = __webpack_public_path__ + "img/052.e228c16f.png";